module.exports = __webpack_public_path__ + "static/media/xlsx-icon.ad63eb5c.svg";